/**
 * Created by Daniela on 23/01/2017.
 */
import { Component, OnInit } from '@angular/core';

import { configuracaoModuleName } from "../../shared/services/data.service";
import { planosModuleName } from "../planos/shared/data.service";
import { servicosModuleName } from "../servicos/shared/data.service";
import { PlanoNavigationService } from "../planos/shared/plano-navigation.service";
import { ServicoNavigationService } from "../servicos/shared/servico-navigation.service";
import { manutencoesModuleName } from "../shared/data.service";

@Component({
    template: require('./manutencao-configuracao.component.html'),
    styles: [require('./manutencao-configuracao.component.css')]
})
export class ManutencaoConfiguracaoComponent implements OnInit {
    module: any = manutencoesModuleName;
    configuracaoModule: any = configuracaoModuleName;
    planoManutencaoModule: any = planosModuleName;
    servicoModule: any = servicosModuleName;

    constructor(
        private _planoNavigationService: PlanoNavigationService,
        private _servicoNavigationService: ServicoNavigationService
    ) { }

    ngOnInit() {
    }

    clickItem(module: any) {
        if (module.plural === this.planoManutencaoModule.plural) {
            this._planoNavigationService.goToList();
        } else if (module.plural === this.servicoModule.plural) {
            this._servicoNavigationService.goToList();
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/configuracao/manutencao-configuracao.component.ts
 **/